"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("../button"));
var _rule = _interopRequireDefault(require("../rule"));
var _linkList = _interopRequireDefault(require("../link-list"));
var _linkListExpander = _interopRequireDefault(require("../link-list-expander"));
var _linkListColumn = _interopRequireDefault(require("../link-list-column"));
var _socialMediaIconGroup = _interopRequireDefault(require("../social-media-icon-group"));
require("./footer.css");
var _excluded = ["links", "headingProps", "lastExpanderInList"],
  _excluded2 = ["alwaysUseMobileLayout", "finePrintText", "languageSelector", "navAriaLabel", "noGutters", "primaryLinkLists", "primaryLinkListsHeadingProps", "secondaryLinkList", "socialMediaIcons", "useCrateLayout", "useMaxWidthLayout"],
  _excluded3 = ["href", "onClick", "text", "targetLocale"];
/* eslint-disable complexity */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var FooterExpanders = function FooterExpanders(_ref) {
  var _ref$links = _ref.links,
    links = _ref$links.links,
    headingText = _ref$links.headingText,
    headingProps = _ref.headingProps,
    lastExpanderInList = _ref.lastExpanderInList,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_linkListExpander["default"], _extends({
    headingProps: headingProps,
    headingText: headingText,
    headingWrapperClassName: "py2 ".concat(lastExpanderInList ? 'mb0' : 'mb2 sm-mb3'),
    linkClassName: "text-noUnderline sb-footer-primaryLinks",
    links: links
  }, otherProps));
};

/**
  An opinionated footer separated into 4 functional sections:
  * - `primaryLinkLists` lives at the top. It contains the main links that direct users to points of interest. Renders as columns or expanders. If `alwaysUseMobileLayout` is true, or number of lists exceed 5, then `primaryLinkLists` only renders as expanders.
  * - Underneath is `socialMediaIcons`, a row of icons that link the user to external social media sites.
  * - Under that is `secondaryLinkList`, a link list of a minimal number of links to direct users to terms and conditions, etc.
  * - And lastly, `finePrintText`, which reserves the web page for Starbucks Coffee Company.
*/

var Footer = function Footer(_ref2) {
  var _ref2$alwaysUseMobile = _ref2.alwaysUseMobileLayout,
    alwaysUseMobileLayout = _ref2$alwaysUseMobile === void 0 ? false : _ref2$alwaysUseMobile,
    _ref2$finePrintText = _ref2.finePrintText,
    finePrintText = _ref2$finePrintText === void 0 ? '' : _ref2$finePrintText,
    _ref2$languageSelecto = _ref2.languageSelector,
    languageSelector = _ref2$languageSelecto === void 0 ? {} : _ref2$languageSelecto,
    navAriaLabel = _ref2.navAriaLabel,
    _ref2$noGutters = _ref2.noGutters,
    noGutters = _ref2$noGutters === void 0 ? false : _ref2$noGutters,
    _ref2$primaryLinkList = _ref2.primaryLinkLists,
    primaryLinkLists = _ref2$primaryLinkList === void 0 ? [] : _ref2$primaryLinkList,
    _ref2$primaryLinkList2 = _ref2.primaryLinkListsHeadingProps,
    primaryLinkListsHeadingProps = _ref2$primaryLinkList2 === void 0 ? {} : _ref2$primaryLinkList2,
    _ref2$secondaryLinkLi = _ref2.secondaryLinkList,
    secondaryLinkList = _ref2$secondaryLinkLi === void 0 ? [] : _ref2$secondaryLinkLi,
    _ref2$socialMediaIcon = _ref2.socialMediaIcons,
    socialMediaIcons = _ref2$socialMediaIcon === void 0 ? [] : _ref2$socialMediaIcon,
    _ref2$useCrateLayout = _ref2.useCrateLayout,
    useCrateLayout = _ref2$useCrateLayout === void 0 ? false : _ref2$useCrateLayout,
    _ref2$useMaxWidthLayo = _ref2.useMaxWidthLayout,
    useMaxWidthLayout = _ref2$useMaxWidthLayo === void 0 ? false : _ref2$useMaxWidthLayo,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var languageHref = languageSelector.href,
    languageOnClick = languageSelector.onClick,
    languageText = languageSelector.text,
    targetLocale = languageSelector.targetLocale,
    otherlanguageProps = _objectWithoutProperties(languageSelector, _excluded3);
  return /*#__PURE__*/_react["default"].createElement("footer", otherProps, /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-label": navAriaLabel,
    className: (0, _classnames["default"])({
      'sb-global-gutters': !noGutters,
      'sb-global-gutters--maxWidthLayout': useMaxWidthLayout && !noGutters,
      'sb-global-gutters--logoOffset': !useCrateLayout && !useMaxWidthLayout && !noGutters
    })
  }, alwaysUseMobileLayout || primaryLinkLists.length > 5 ? primaryLinkLists.map(function (links, i) {
    return /*#__PURE__*/_react["default"].createElement(FooterExpanders, {
      headingProps: primaryLinkListsHeadingProps,
      key: "contentCrateExpander-".concat(i),
      lastExpanderInList: i === primaryLinkLists.length - 1,
      links: links
    });
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "lg-flex"
  }, primaryLinkLists.map(function (links, i) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "fullPageWidth-".concat(i)
    }, /*#__PURE__*/_react["default"].createElement(FooterExpanders, {
      className: "lg-hidden",
      headingProps: primaryLinkListsHeadingProps,
      lastExpanderInList: i === primaryLinkLists.length - 1,
      links: links
    }), /*#__PURE__*/_react["default"].createElement(_linkListColumn["default"], {
      className: "sb-footer-columnWidth hidden lg-inline-block ".concat(i !== 0 ? 'lg-ml5' : ''),
      headingProps: primaryLinkListsHeadingProps,
      headingText: links.headingText,
      linkClassName: "text-noUnderline sb-footer-primaryLinks",
      links: links.links
    }));
  })), /*#__PURE__*/_react["default"].createElement(_rule["default"], {
    className: "py5"
  }), /*#__PURE__*/_react["default"].createElement(_socialMediaIconGroup["default"], {
    className: "sb-footer-iconMarginAdjust",
    linkItems: socialMediaIcons,
    listItemClassName: "sm-mr1"
  }), /*#__PURE__*/_react["default"].createElement(_linkList["default"], {
    className: "mt3 lg-mb1",
    inlineAboveBreakpoint: alwaysUseMobileLayout || secondaryLinkList.length > 6 ? null : 'lg',
    linkClassName: "sb-footer-secondaryLinks mb1 py2 ".concat(alwaysUseMobileLayout || secondaryLinkList.length > 6 ? 'lg-mb1 lg-py2' : 'lg-mb0 lg-py0'),
    links: secondaryLinkList,
    paddingBetweenInlineLinks: 3
  }), !(0, _isEmpty2["default"])(languageSelector) && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-left mt3 mb1 lg-mt5"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    className: "p0",
    href: languageHref,
    hrefLang: targetLocale,
    interactive: false,
    lang: targetLocale,
    onClick: languageOnClick,
    rel: "alternate",
    visualStyle: "textOnly"
  }, otherlanguageProps), languageText)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "color-textBlackSoft py3 text-xxs"
  }, finePrintText)));
};
Footer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Will the Footer be a ContentCrate or have the full width of the window? When set to `true`, the `primaryLinkLists` will render in columns and `secondaryLinkList` will render inline above the large breakpoint (1024px). When set to false, `primaryLinkLists` renders in `CaretExpanders` only, and `secondaryLinkList` in block. */
  alwaysUseMobileLayout: _propTypes["default"].bool,
  /** Applied to the <footer> tag. */
  className: _propTypes["default"].string,
  /** Shows language selector. If nothing is passed, the selector will not be shown. */
  languageSelector: _propTypes["default"].shape({
    /** The text of the link */
    text: _propTypes["default"].string,
    /** The href of the link to change the language */
    href: _propTypes["default"].string,
    /** The function that calls a language change */
    onClick: _propTypes["default"].func,
    /** The language of the text */
    targetLocale: _propTypes["default"].string
  }),
  /**
   * If your app includes multiple nav elements, include an aria label to help distinguish
   * each nav region. Note that the screenreader will add the word "navigation",
   * so that term is repetitive in any aria label. A good label might be 'Global footer'.
   */
  navAriaLabel: _propTypes["default"].string,
  /** The main footer content; renders lists of links in either columns or expanders. If number of lists is more than 5, lists are rendered in expanders only. */
  primaryLinkLists: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** The text sent as the heading of each `primaryLinkLists` group */
    headingText: _propTypes["default"].any.isRequired,
    /** Each child link for a `primaryLinkLists` group */
    links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      /** The text of the link */
      text: _propTypes["default"].any.isRequired,
      /** The href of the link */
      href: _propTypes["default"].string,
      /**
       * Tag for the link, defaults to a standard anchor if not present
       */
      tagName: _propTypes["default"].any,
      /**
       * When using React Router, the links will often receive a 'to' prop
       */
      to: _propTypes["default"].string
    }))
  })),
  /** Props to pass through to `Heading`, including `tagName`, `size`, `className`, etc. See `Heading` for more info.
   */
  primaryLinkListsHeadingProps: _propTypes["default"].shape({
    tagName: _propTypes["default"].any,
    size: _propTypes["default"].string
  }),
  /** Data sent to `SocialMediaIconGroup` */
  socialMediaIcons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** Names available: 'facebook', 'instagram', 'pinterest', 'spotify', 'x', 'youtube' */
    name: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired,
    /** Label for social media icon. Defaults to name of icon. */
    ariaLabel: _propTypes["default"].string
  })),
  /** A secondary footer list, good for any content that doesn't fit in the primary lists. If number of links is more than 6, lists are rendered in block only */
  secondaryLinkList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** The text of the link */
    text: _propTypes["default"].any.isRequired,
    /** The href of the link */
    href: _propTypes["default"].string,
    /**
     * Tag for the link, defaults to a standard anchor
     */
    tagName: _propTypes["default"].any,
    /**
     * When using React Router, the links will often receive a 'to' prop
     */
    to: _propTypes["default"].string
  })),
  /** Text to reserve copyright at bottom of footer. */
  finePrintText: _propTypes["default"].any,
  /**
   * Remove any preset left/right padding on the footer element
   */
  noGutters: _propTypes["default"].bool,
  /**
   * Set to true for pages using the HeaderCrate and ContentCrate to get proper gutters
   */
  useCrateLayout: _propTypes["default"].bool,
  /**
   * Set to true to have it align with pages like the starbucks.com homepage,
   * whose content blocks use the max content column size
   */
  useMaxWidthLayout: _propTypes["default"].bool
} : {};
Footer.displayName = 'Footer';
var _default = exports["default"] = Footer;